export default __webpack_public_path__ + "images/16889fa41.png";